// extracted by mini-css-extract-plugin
export default {"container":"Login_container__sVz9N","form":"Login_form__EdsYV","form__button":"Login_form__button__kBj0q","link":"Login_link__VT80v"};